<template>
  <v-dialog v-model="dOpenComponente" persistent full-width>
    <v-card>
      <!-- cabecera del dialogo -->
      <v-toolbar dark class="datModalTitleContainer">
        <v-toolbar-title>
          {{dInformeComponente.nombre}}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark @click="fCerrarVentana()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-form ref="form">
        <v-flex>
          <ShpInitPresupuestos @alert="fAlert" @loading="fLoading" :pLimitDate="dLimitDate"></ShpInitPresupuestos>
        </v-flex>
      </v-form>
    </v-card>
  </v-dialog>
</template>
<script>

import ShpInitPresupuestos from '@/components/Informes/Presupuestos/ShpInitPresupuestos'

export default {
  components: {
    ShpInitPresupuestos
  },
  props: {
    pInformeComponente: {
      type: Object,
      required: true,
      default: false
    },
    pLimitDate: {
      type: Object,
      required: true,
      default: false
    }
  },
  data () {
    return {
      dOpenComponente: true,
      dInformeComponente: {},
      dLimitDate: {}
    }
  },
  mounted () {
    this.dInformeComponente = this.pInformeComponente
    this.dLimitDate = this.pLimitDate
  },
  methods: {
    fAlert (msg) {
      this.$emit('alert', msg)
    },
    fCerrarVentana () {
      this.$emit('close')
    },
    fLoading (msg) {
      this.$emit('loading', msg)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Informes/Presupuestos/ShpPresupuestos.vue